import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

const TOKEN_KEY = "pp_token";
export function setToken(t, remember = true) {
  localStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
  if (t) (remember ? localStorage : sessionStorage).setItem(TOKEN_KEY, t);
}
export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);
}

const ll = (p) => (Array.isArray(p) ? `${p[0]},${p[1]}` : `${p.lat},${p.lng}`);
export function googleRouteUrl(home, stores) {
  if (!stores?.length) return null;
  const dest = stores[stores.length - 1];
  const mid = stores.slice(0, -1).map((s) => encodeURIComponent(s.address || ll(s)));
  let u = `https://www.google.com/maps/dir/?api=1&origin=${ll(home)}&destination=${encodeURIComponent(dest.address || ll(dest))}&travelmode=driving`;
  if (mid.length) u += `&waypoints=${mid.join("%7C")}`;
  return u;
}
export function appleRouteUrl(home, store) {
  return `https://maps.apple.com/?saddr=${ll(home)}&daddr=${encodeURIComponent(store.address || ll(store))}&dirflg=d`;
}
export async function compressImage(file, max = 1600) {
  const img = await new Promise((res, rej) => {
    const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = URL.createObjectURL(file);
  });
  const scale = Math.min(1, max / Math.max(img.width, img.height));
  const c = document.createElement("canvas");
  c.width = Math.round(img.width * scale); c.height = Math.round(img.height * scale);
  c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
  return c.toDataURL("image/jpeg", 0.85).split(",")[1];
}
client.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function apiErr(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function money(n) {
  if (n == null || isNaN(n)) return "—";
  return "$" + Number(n).toFixed(2);
}

export const STORE_COLORS = {
  walmart: "#0071CE", costco: "#E31837", superstore: "#1A3C8B", nofrills: "#F5BE41",
  safeway: "#E31837", sobeys: "#00833E", saveonfoods: "#007934", freshco: "#84BD00", coop: "#D3122A",
};

export default client;
